<template>
  <a :href="link" class="btn-wrapper">
    <div class="img-wrapper">
      <img :src="img1x" :srcset="img2x" :alt="alt">
    </div>
    <div class="text">Designed for use with:<br /><b>{{ productName }}</b><br /><small>{{ productSub }}</small></div>
  </a>
</template>

<script>
  export default {
    name: 'ctaprodbutton',

    props: {
      link: {
        required: true,
        type: String
      },
      src: {
        required: true,
        type: String
      },
      src2:  {
        required: true,
        type: String
      },
      alt: {
        required: true,
        type: String
      },
      productName: {
        required: true,
        type: String
      },
      productSub: {
        type: String
      }
    },

    computed: {
      img1x() {
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + this.src;
      },

      img2x() {
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + this.src2 + ' 2x';
      }
    }
  }
</script>

<style lang="scss" scoped>
.btn-wrapper {
  width: 100%;
  height: 94px;
  max-width: 324px;
  border-radius: 5px;
  background-color: var(--white);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  margin: 35px 0 20px;
  padding: 8px;
}

img {
  width: 90px;
  height: 78px;
}

a {
  display: flex;
  font-family: var(--roboto);
  color: #333;
  text-decoration: none;
  cursor: pointer;
}

a .text {
  font-size: 0.9375rem;
  line-height: 1.467;
  align-self: center;
  justify-self: center;
  margin: 3px 10px 3px 13px;
}

a .text b {
  font-size: 1rem;
  line-height: 1.3125;
  font-weight: 700;
}

a .text small {
  font-size: 0.75rem;
  line-height: 1.55;
  color: #5f6062;
}

@media only screen and (max-width:361px) {
  a .text {
    font-size: .75rem;
  }

  a .text b {
    font-size: 0.8rem;
  }

  a .text small {
    font-size: .5rem;
  }
}
</style>